import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-popup_ic_warning",
  "use": "icon-popup_ic_warning-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-popup_ic_warning\"><clipPath id=\"icon-popup_ic_warning_a\"><path d=\"m0 0h16v16h-16z\" /></clipPath><g clip-path=\"url(#icon-popup_ic_warning_a)\" fill=\"#999\"><path d=\"m8 15.17c-3.95 0-7.17-3.21-7.17-7.17s3.22-7.17 7.17-7.17 7.17 3.21 7.17 7.17-3.21 7.17-7.17 7.17zm0-13.34c-3.4 0-6.17 2.77-6.17 6.17s2.77 6.17 6.17 6.17 6.17-2.77 6.17-6.17-2.77-6.17-6.17-6.17z\" /><path d=\"m8 9.17c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5s.5.22.5.5v4c0 .28-.22.5-.5.5z\" /><path d=\"m8 11.5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75-.75.34-.75.75.34.75.75.75z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/popup_ic_warning.svg
// module id = jIYN
// module chunks = 87